module.exports = __webpack_public_path__ + "img/gh-12205-4.prt.710d92d5.jpg";